import { z } from 'zod';
import { UserRole, UserStatus } from '../types/user.types';

export const createUserSchema = z.object({
  email: z.string().email('Email i pavlefshëm'),
  password: z.string().min(8, 'Fjalëkalimi duhet të ketë të paktën 8 karaktere'),
  firstName: z.string().min(2).max(50),
  lastName: z.string().min(2).max(50),
  role: z.nativeEnum(UserRole),
  phone: z.string().optional(),
  position: z.string().max(100).optional(),
  zoneIds: z.array(z.string().uuid()).optional(),
  topicIds: z.array(z.string().uuid()).optional(),
  sendEmail: z.boolean().optional().default(false),
});

export const updateUserSchema = z.object({
  firstName: z.string().min(2).max(50).optional(),
  lastName: z.string().min(2).max(50).optional(),
  role: z.nativeEnum(UserRole).optional(),
  status: z.nativeEnum(UserStatus).optional(),
  phone: z.string().optional(),
  position: z.string().max(100).optional(),
  zoneIds: z.array(z.string().uuid()).optional(),
  topicIds: z.array(z.string().uuid()).optional(),
});

export const resetPasswordSchema = z.object({
  newPassword: z.string().min(8, 'Fjalëkalimi duhet të ketë të paktën 8 karaktere'),
  sendEmail: z.boolean().optional().default(false),
});

export const importUserSchema = z.object({
  email: z.string().email('Email i pavlefshëm'),
  password: z.string().min(8, 'Fjalëkalimi duhet të ketë të paktën 8 karaktere').optional(),
  firstName: z.string().min(2).max(50),
  lastName: z.string().min(2).max(50),
  role: z.nativeEnum(UserRole).optional(),
  phone: z.string().optional(),
  position: z.string().max(100).optional(),
});

export const importBatchSchema = z.object({
  users: z.array(importUserSchema).min(1).max(500),
  options: z.object({
    sendWelcomeEmail: z.boolean().default(false),
    autoGeneratePasswords: z.boolean().default(true),
    defaultRole: z.nativeEnum(UserRole).default(UserRole.USER),
    defaultStatus: z.nativeEnum(UserStatus).default(UserStatus.ACTIVE),
  }),
});

export type CreateUserInput = z.infer<typeof createUserSchema>;
export type UpdateUserInput = z.infer<typeof updateUserSchema>;
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;
export type ImportUserInput = z.infer<typeof importUserSchema>;
export type ImportBatchInput = z.infer<typeof importBatchSchema>;
